(function () {
  'use strict';

  // Adds the condition label ("Brand New" / "Modern" / "Vintage") to cards in Searchanise results.
  //
  // Searchanise renders its product grid client-side, so snippets/sbs-brand-new-label.liquid
  // never runs for those cards. This mirrors that snippet's rules - keep the two in step,
  // including HIDDEN_HANDLES below (the snippet's sbs_hidden_handles).
  // Searchanise puts vendor and tag classes on each card, built from their handles
  // ("Stüssy" -> snize-product-vendor-stssy, "House Of Sunny" -> snize-product-vendor-house-of-sunny),
  // and marks sold out cards with snize-product-out-of-stock.
  //
  // Watches document.body rather than #snize_results, so it doesn't depend on when or where
  // Searchanise builds its results container.
  // Styles (.sbs-brand-new-badge, .product-label--sbs) live in assets/sbs-custom.css.

  var CARD_SELECTOR = '.snize-product[data-original-product-id]:not([data-sbs-brand-new])';
  var SOLD_OUT_RE = /(^|\s)snize-product-out-of-stock(\s|$)/;
  var STUSSY_VENDOR_RE = /(^|\s)snize-product-vendor-st(u|ü)?ssy(\s|$)/;
  var NOT_VINTAGE_RE =
    /(^|\s)snize-product-(vendor-(sourcedbysab|house-of-sunny)|tag-(deadstock|mysterybox|mystery))(\s|$)/;
  var MYSTERY_TITLE_RE = /mystery/i;
  // Jerseys tagged "modern" show "Modern" instead of "Vintage". Only the title is on the card,
  // so unlike the snippet this can't also check the product type.
  var MODERN_TAG_RE = /(^|\s)snize-product-tag-modern(\s|$)/;
  var JERSEY_TITLE_RE = /jersey|football shirt/i;

  // Products that never show a condition label, by handle.
  var HIDDEN_HANDLES = ['vintage-carhartt-green-hoodie-s-796457'];

  function handleOf(card) {
    var link = card.querySelector('a[href*="/products/"]');
    var match = link && /\/products\/([^/?#]+)/.exec(link.getAttribute('href') || '');
    return match ? match[1] : '';
  }

  function labelFor(card) {
    var classes = card.className;
    if (SOLD_OUT_RE.test(classes)) return null;
    if (HIDDEN_HANDLES.indexOf(handleOf(card)) !== -1) return null;
    if (STUSSY_VENDOR_RE.test(classes)) return { text: 'Brand New', modifier: 'brand-new' };
    if (NOT_VINTAGE_RE.test(classes)) return null;

    var titleEl = card.querySelector('.snize-title');
    if (titleEl && MYSTERY_TITLE_RE.test(titleEl.textContent)) return null;

    if (titleEl && JERSEY_TITLE_RE.test(titleEl.textContent) && MODERN_TAG_RE.test(classes)) {
      return { text: 'Modern', modifier: 'modern' };
    }

    return { text: 'Vintage', modifier: 'vintage' };
  }

  function labelCard(card) {
    var thumb = card.querySelector('.snize-thumbnail-wrapper');
    if (!thumb) return;
    card.setAttribute('data-sbs-brand-new', '1');

    var label = labelFor(card);
    if (!label) return;

    var badge = document.createElement('div');
    badge.className = 'sbs-brand-new-badge';
    badge.innerHTML =
      '<span class="product-label product-label--sbs product-label--' + label.modifier + '">' +
      '<span>' + label.text + '</span></span>';
    thumb.appendChild(badge);
  }

  var queued = false;

  function labelAll() {
    queued = false;
    document.querySelectorAll(CARD_SELECTOR).forEach(labelCard);
  }

  // Searchanise inserts many nodes per render - batch them into one pass per frame.
  function queueLabelAll() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(labelAll);
  }

  function init() {
    new MutationObserver(queueLabelAll).observe(document.body, { childList: true, subtree: true });
    labelAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
